export default "__VITE_ASSET__bd47d795__"